module.exports = __webpack_public_path__ + "img/gongzhonghao@2x.476b196e.png";